/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_BOXES_YEAR } from "../graphql/getYearFilter.query";

const is = require("is_js");
const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetBoxesYearMethods extends IPluginMethodMap {
    getBoxesYear(): Promise<any>;
}

export class GetBoxesYearService implements IAgentPlugin {
    readonly methods: IGetBoxesYearMethods;
    private exchangeRate: any = 1;

    constructor() {
        this.methods = {
            getBoxesYear: this.getBoxesYear.bind(this),
        };
    }

    async getBoxesYear() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_BOXES_YEAR,
                    variables: {},
                    fetchPolicy: "network-only",
                });
                let year: any[] = []
                console.log(res?.data?.getMyBoxes?.content, is.not.empty(res?.data?.getMyBoxes?.content))
                if (
                    res?.data?.getMyBoxes?.content &&
                    is.not.empty(res?.data?.getMyBoxes?.content)
                ) {

                    const myYear = this.transformData(res?.data?.getMyBoxes?.content);
                    year = [...myYear];
                    console.log(year);
                }
                const uniqueData = this.removeDuplicates(year);
                console.log(Array.isArray(uniqueData))
                uniqueData && uniqueData.length > 0 &&
                    uniqueData.sort((a: any, b: any) => b.value - a.value);
                console.log(uniqueData);
                return uniqueData;
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }
    private transformData = (data) => {
        const contentArray = data;
        return contentArray && contentArray.map((item: any) => {
            const year = parseInt(item?.presentation?.year, 10);
            return {
                label: year,
                value: year
            };
        });
    };

    private removeDuplicates = (data) => {
        const seen = new Set();
        return data.filter(item => {
            if (seen.has(item.value)) {
                return false;
            } else {
                seen.add(item.value);
                return true;
            }
        });
    };
}
